export default "https://cdn-static.gokick.com/assets/90becb6b185a352a9c07d0641a2a2a86ee77cb9a/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";